import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
})
export default class AppHome extends Vue {
    get snackbar() {
        return this.$store.getters.hasApplicationMessages;
    }

    dimiss() {
        console.log('user dismissed messages');
        this.$store.dispatch('clearMessages');
    }

    mounted() {
        this.$store.dispatch('clearMessages');
        this.$store.dispatch('isLoading', false);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/src/app.ts